import { DownOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Drawer } from 'antd';
import LoginModal from 'components/LoginModal/LoginModal';
import CountDownFinal from 'components/Header/CountDownFinal';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getAllSetting } from '../../service/base';
import { CONST_SITE, LocalStorageKey } from '../../utils/common/const';
import {
  AUTH_CHANGED_EVENT,
  clearAuthSession,
  getStoredAccessToken,
  OPEN_LOGIN_MODAL_EVENT,
  requestOpenLoginModal
} from '../../utils/authSession';

/** Ảnh trong `public/` — dùng PUBLIC_URL để không đưa url() vào global.css (webpack/css-loader không resolve được). */
const pub = (path) => `${process.env.PUBLIC_URL || ''}${path}`;

const navItems = [
  {
    // name: 'Dự đoán',
    href: '/',
    icon: '/assets/images/header/btn_dudoan.png',
    iconActive: '/assets/images/header/btn_dudoan_active.png'
  },
  {
    // name: 'Thể lệ',
    href: '/rule',
    icon: '/assets/images/header/btn_thele.png',
    iconActive: '/assets/images/header/btn_thele_active.png'
  },
  {
    // name: 'Kết quả',
    href: '/prize-structure',
    icon: '/assets/images/header/btn_ketqua.png',
    iconActive: '/assets/images/header/btn_ketqua_active.png'
  }
];

const HeaderMenu = () => {
  const [settings, setSettings] = useState({
    link_login: '#',
    link_register: '#',
    link_home: '#'
  });
  const location = useLocation();
  const activeNav = location.pathname;
  const mounted = useRef(false);
  const [isShowMenu, setIsShowMenu] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [authUser, setAuthUser] = useState(null);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);

  const syncAuthFromStorage = useCallback(() => {
    const token = localStorage.getItem(LocalStorageKey.ACCESS_TOKEN);
    if (!token) {
      setAuthUser(null);
      return;
    }
    const username = localStorage.getItem('hi88_login_username') || 'Thành viên';
    setAuthUser({ username });
  }, []);

  useEffect(() => {
    syncAuthFromStorage();
    const onAuth = () => syncAuthFromStorage();
    const onStorage = (e) => {
      if (e.key === LocalStorageKey.ACCESS_TOKEN || e.key === 'hi88_login_username') {
        syncAuthFromStorage();
      }
    };
    window.addEventListener(AUTH_CHANGED_EVENT, onAuth);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(AUTH_CHANGED_EVENT, onAuth);
      window.removeEventListener('storage', onStorage);
    };
  }, [syncAuthFromStorage]);

  useEffect(() => {
    const onOpenLogin = () => setLoginModalOpen(true);
    window.addEventListener(OPEN_LOGIN_MODAL_EVENT, onOpenLogin);
    return () => window.removeEventListener(OPEN_LOGIN_MODAL_EVENT, onOpenLogin);
  }, []);

  useEffect(() => {
    if (!userMenuOpen) return;
    const onDown = (e) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setUserMenuOpen(false);
      }
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setUserMenuOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [userMenuOpen]);

  const handleLogout = () => {
    clearAuthSession();
    setAuthUser(null);
    setUserMenuOpen(false);
  };

  const handleHistoryLinkClick = useCallback((e, { closeDrawer = false } = {}) => {
    if (!getStoredAccessToken()) {
      e.preventDefault();
      if (closeDrawer) setIsShowMenu(false);
      requestOpenLoginModal();
      return;
    }
    if (closeDrawer) setIsShowMenu(false);
  }, []);

  useEffect(() => {
    mounted.current = true;

    const fetchData = async () => {
      try {
        const res = await getAllSetting({
          site: CONST_SITE.HI88
        });
        if (mounted.current) {
          const settingsMap = {};
          res.data.forEach((item) => {
            settingsMap[item.key] = item.content || '#';
          });
          setSettings(settingsMap);
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchData();

    return () => {
      mounted.current = false;
    };
  }, []);

  return (
    <div className="w-full">
      <div
        className="w-full"
        style={{ background: 'linear-gradient(180deg, #FFFFFF 0%, #C5EEFF 100%)' }}
      >
        <div
          className="flex flex-row justify-between items-center w-full max-w-[1200px] mx-auto px-[8px] md:px-[26px] py-[8px] md:py-[13px] gap-[5px] md:gap-[10px] 
             h-[60px] md:h-[80px]"
        >
          <div className="flex md:hidden justify-start w-full md:w-1/5">
            <Drawer
              placement="left"
              onClose={() => setIsShowMenu(false)}
              open={isShowMenu}
              closeIcon={null}
              width={260}
              bodyStyle={{ padding: 0, position: 'relative' }}
              style={{
                // Hide scrollbar for the Drawer
                overflow: 'auto',
                scrollbarWidth: 'none', // For Firefox
                msOverflowStyle: 'none', // For IE, Edge
                background: 'linear-gradient(180deg, #FFFFFF 0%, #C5EEFF 100%)'
              }}
              // For Ant Design Drawer: pass className to customize scrollbar for inner content
              className="drawer-hide-scrollbar"
            >
              {/* Inline scrollbar-hide CSS for injected content */}
              <style>
                {`
                  .drawer-hide-scrollbar {
                    scrollbar-width: none !important;        /* Firefox */
                    -ms-overflow-style: none !important;     /* IE and Edge */
                  }
                  .drawer-hide-scrollbar::-webkit-scrollbar {
                    display: none !important;                /* Chrome, Safari and Opera */
                    width: 0 !important;
                    background: transparent !important;
                  }
                `}
              </style>
              {/* Logo on Top */}
              <div
                className="flex items-center justify-center w-full py-6 border-b border-gray-200"
                // style={{ background: '#26A9E0' }}
              >
                <Link to="/" onClick={() => setIsShowMenu(false)}>
                  <img
                    src="/assets/images/header/logo.png"
                    alt="Logo"
                    className="h-[48px] w-auto object-contain mx-auto"
                  />
                </Link>
              </div>
              {/* Close Button X */}
              <button
                onClick={() => setIsShowMenu(false)}
                className="absolute top-3 right-3 z-10 text-grayhover:text-gray-400 transition-colors"
                aria-label="Đóng menu"
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: 32,
                  lineHeight: 1,
                  cursor: 'pointer'
                }}
              >
                ×
              </button>
              {/* Hide scrollbar for this menu list as well */}
              <div
                className="flex flex-col h-full"
                // style={{ background: '#26A9E0', overflow: 'auto' }}
                style={{ background: 'linear-gradient(180deg, #FFFFFF 0%, #C5EEFF 100%)' }}
              >
                <Link
                  to="/"
                  onClick={() => {
                    setIsShowMenu(false);
                  }}
                  className="flex items-center px-5 py-4 border-b border-blue-900 hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#26A9E0] transition-colors"
                >
                  Dự đoán
                </Link>
                <Link
                  to="/rule"
                  onClick={() => {
                    setIsShowMenu(false);
                  }}
                  className="flex items-center px-5 py-4 border-b border-blue-900 hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#26A9E0] transition-colors"
                >
                  Thể lệ
                </Link>
                <Link
                  to="/prize-structure"
                  onClick={() => {
                    setIsShowMenu(false);
                  }}
                  className="flex items-center px-5 py-4 border-b border-blue-900 hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#26A9E0] transition-colors"
                >
                  Kết quả
                </Link>
                <Link
                  to="/history"
                  onClick={(e) => handleHistoryLinkClick(e, { closeDrawer: true })}
                  className="flex items-center justify-start px-5 py-8 font-bold text-xl w-full text-left text-[#26A9E0] transition-colors group border-b border-blue-900 hover:bg-blue-800 hover:text-yellow-300"
                >
                  <span className="group-hover:text-yellow-300 w-full block transition-colors">
                    Lịch sử
                  </span>
                </Link>
                {authUser ? (
                  <div className="px-5 py-4 border-b border-blue-900">
                    <p className="text-sm text-gray-500 mb-0.5">Xin chào</p>
                    <p className="font-bold text-lg text-gray-900 mb-3 truncate">
                      {authUser.username}
                    </p>
                    <button
                      type="button"
                      className="w-full rounded-xl bg-white shadow border border-gray-100 py-2.5 px-4 text-left text-sm font-medium text-[#0f172a] hover:bg-slate-50 transition-colors cursor-pointer"
                      onClick={() => {
                        setIsShowMenu(false);
                        handleLogout();
                      }}
                    >
                      Đăng xuất
                    </button>
                  </div>
                ) : (
                  <>
                    <button
                      type="button"
                      className="flex items-center border-none px-5 py-4 border-b border-blue-900 hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#26A9E0] transition-colors w-full text-left bg-transparent cursor-pointer"
                      onClick={() => {
                        setIsShowMenu(false);
                        setLoginModalOpen(true);
                      }}
                    >
                      Đăng nhập
                    </button>
                    <Link
                      to={settings.link_register}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center px-5 py-4 border-b border-blue-900 hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#26A9E0] transition-colors"
                      onClick={() => {
                        setIsShowMenu(false);
                      }}
                    >
                      Đăng ký
                    </Link>
                  </>
                )}
              </div>
            </Drawer>
            <Button type="link" onClick={() => setIsShowMenu(true)}>
              <img
                src="/assets/images/header/menu.png"
                alt=""
                className="h-[32px] w-[32px] md:w-auto object-contain"
              />
            </Button>
          </div>
          <div className="flex justify-start w-full mt-2">
            <Link
              to={'/'}
              onClick={() => {
                setIsShowMenu(false);
              }}
            >
              <img
                src="/assets/images/header/logo.png"
                alt=""
                className="h-[52px] md:h-[72px] w-auto object-contain"
              />
            </Link>
          </div>

          <div
            className="flex justify-end items-center w-full hide-scrollbar"
            style={{
              height: '100vh',
              overflowY: 'auto'
            }}
          >
            {/* Hide native scrollbar for both Webkit and Firefox */}
            <style>
              {`
                .hide-scrollbar {
                  scrollbar-width: none; /* Firefox */
                  -ms-overflow-style: none;  /* IE and Edge */
                }
                .hide-scrollbar::-webkit-scrollbar {
                  display: none; /* Chrome, Safari and Opera */
                  width: 0 !important;
                  background: transparent !important;
                }
              `}
            </style>
            <Link
              to={settings.link_home}
              target="_blank"
              className="md:hidden w-[90px] h-[90px] flex items-center justify-center"
            >
              <img
                src="/assets/images/header/home.png"
                alt="Đăng nhập"
                className="max-w-full max-h-full object-contain transition-all transform duration-150 ease-out hover:scale-105 hover:-translate-y-1 hover:shadow-lg"
              />
            </Link>
            <div className="hidden md:flex flex-row items-center justify-end gap-2 w-full h-full">
              {authUser ? (
                <div className="relative" ref={userMenuRef}>
                  <button
                    type="button"
                    onClick={() => setUserMenuOpen((v) => !v)}
                    className="flex flex-row items-center gap-2 pl-1 pr-0 py-1 border-0 bg-transparent cursor-pointer rounded-lg hover:bg-white/40 transition-colors"
                    aria-expanded={userMenuOpen}
                    aria-haspopup="menu"
                  >
                    <div className="text-right min-w-0">
                      <div className="text-xs text-gray-500 leading-tight">Xin chào</div>
                      <div className="text-sm font-bold text-gray-900 truncate max-w-[140px] leading-tight">
                        {authUser.username}
                      </div>
                    </div>
                    <div
                      className="h-9 w-9 md:h-10 md:w-10 shrink-0 rounded-full flex items-center justify-center text-white"
                      style={{ backgroundColor: '#26A9E0' }}
                    >
                      <UserOutlined className="text-lg" />
                    </div>
                    <DownOutlined
                      className={`text-gray-700 text-xs shrink-0 transition-transform duration-200 ${userMenuOpen ? 'rotate-180' : ''}`}
                    />
                  </button>
                  {userMenuOpen ? (
                    <div
                      className="absolute right-0 top-full mt-1 z-[100] min-w-[168px] rounded-xl bg-white shadow-lg border border-gray-100 py-1"
                      role="menu"
                    >
                      <button
                        type="button"
                        role="menuitem"
                        onClick={handleLogout}
                        className="w-full text-left px-4 py-2.5 text-sm font-medium text-[#0f172a] hover:bg-slate-50 cursor-pointer border-0 bg-transparent"
                      >
                        Đăng xuất
                      </button>
                    </div>
                  ) : null}
                </div>
              ) : (
                <>
                  <button
                    type="button"
                    onClick={() => setLoginModalOpen(true)}
                    className="w-[90px] h-[26px] md:w-[118px] md:h-[33px] flex items-center justify-center border-0 p-0 bg-transparent cursor-pointer"
                  >
                    <img
                      src="/assets/images/header/login.png"
                      alt="Đăng nhập"
                      className="max-w-full max-h-full object-contain transition-all transform duration-150 ease-out hover:scale-105 hover:-translate-y-1 hover:shadow-lg"
                    />
                  </button>
                  <Link
                    to={settings.link_register}
                    target="_blank"
                    className="w-[90px] h-[26px] md:w-[118px] md:h-[33px] flex items-center justify-center"
                  >
                    <img
                      src="/assets/images/header/register.png"
                      alt="Đăng ký"
                      className="max-w-full max-h-full object-contain transform transition-all duration-150 ease-out hover:scale-105 hover:-translate-y-1 hover:shadow-lg"
                    />
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mx-auto flex w-full max-w-[1246px] flex-col items-center justify-center px-2 md:px-0">
        <img
          src="/assets/images/header/linhvat.gif"
          alt=""
          className="w-full max-w-[320px] h-auto object-contain md:max-w-[594px]"
          draggable={false}
        />
        <img
          src="/assets/images/header/bannerpc_new.png"
          alt=""
          className="w-full h-auto object-contain -mt-12 md:-mt-32"
          draggable={false}
        />
      </div>

      <div className="flex flex-row justify-center items-center w-full gap-2 sm:gap-4 lg:gap-6 md:py-3 py-0 px-2 mt-1 md:mt-2">
        {navItems.map((item) => {
          const isActive = activeNav === item.href;
          return (
            <Link
              key={item.href}
              to={item.href}
              className={`text-center min-w-[68px] text-[10px] md:text-[14px] font-semibold flex items-center justify-center transition-colors duration-200 w-auto h-[50px] bg-transparent`}
            >
              <img
                src={isActive ? item.iconActive : item.icon}
                alt="Lịch sử"
                className="w-full h-full object-contain"
              />
            </Link>
          );
        })}
        <Link
          to="/history"
          onClick={handleHistoryLinkClick}
          className="text-center text-[12px] md:text-[14px] font-semibold text-white hover:text-white/80 transition-colors duration-200 flex items-center justify-center w-auto h-[50px] bg-transparent"
        >
          <img
            src="/assets/images/header/btn_lichsu.png"
            alt="Lịch sử"
            className="w-full h-full object-contain"
          />
        </Link>
      </div>
      {/* </div> */}

      {/* Đồng hồ đếm ngược World Cup 2026 — Figma 95:399 */}
      <div className="mx-auto w-full max-w-[1200px] px-2 pb-2 md:px-[26px] md:pb-3">
        <div className="relative overflow-hidden rounded-2xl border-2 border-[#26A9E0]/60 shadow-sm backdrop-blur-[12px]">
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat md:hidden"
            style={{ backgroundImage: `url("${pub('/assets/images/header/cd_bg_mb.png')}")` }}
            aria-hidden
          />
          <div
            className="absolute inset-0 hidden bg-cover bg-center bg-no-repeat md:block"
            style={{ backgroundImage: `url("${pub('/assets/images/header/cd_bg.png')}")` }}
            aria-hidden
          />
          <div className="relative z-[1] flex min-h-[72px] w-full flex-row items-center justify-between gap-2 px-2 py-1.5 md:min-h-[88px] md:gap-4 md:px-6 md:py-1">
            <img
              src={pub('/assets/images/header/cd_left.png')}
              alt="FIFA World Cup 2026"
              className="h-11 w-auto max-w-[45%] shrink-0 object-contain object-left md:h-[86px] md:max-w-none"
              draggable={false}
            />
            <img
              src={pub('/assets/images/header/cd_center.png')}
              alt=""
              className="hidden h-auto max-h-[68px] w-auto shrink object-contain md:block md:max-h-[97px]"
              draggable={false}
            />
            <CountDownFinal />
          </div>
        </div>
      </div>

      <LoginModal isOpen={loginModalOpen} onClose={() => setLoginModalOpen(false)} />
    </div>
  );
};

export default HeaderMenu;
